var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3973 14.4167L19.9937 8.63427C20.0174 8.56324 20.0294 8.48774 20.0294 8.4094C20.0294 8.0007 19.6801 7.66675 19.2469 7.66675C19.0011 7.66675 18.7824 7.77175 18.6396 7.94069L10.6705 17.7016C10.5635 17.829 10.5 17.9905 10.5 18.1667C10.5 18.5791 10.8574 18.9168 11.2941 18.9168H16.1022L14.5063 24.6992C14.4822 24.7707 14.4705 24.8458 14.4705 24.9241C14.4705 25.3332 14.82 25.6667 15.2527 25.6667C15.4989 25.6667 15.7172 25.5621 15.8602 25.3928L23.829 15.6318C23.9364 15.5044 24 15.3433 24 15.1667C24 14.7544 23.6424 14.4167 23.206 14.4167H18.3973Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.fc3fde32e8120817f63f71dbd051863e.svg";
export { ForwardRef as ReactComponent };